import { tlds } from './tlds'

type Options = {
  strict?: boolean
  exact?: boolean
}
// code mostly taken from: https://www.npmjs.com/package/url-regex
export const urlRegex = (options?: Options): RegExp => {
  options = {
    strict: false,
    exact: false,
    ...options
  }

  const protocol = `(?:(?:(https|http)+:)?//)${options.strict ? '' : '?'}`
  const auth = '(?:\\S+(?::\\S*)?@)?'
  const host = '(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)'
  const domain =
    '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*'
  const tld = `(?:\\.${
    options.strict
      ? '(?:[a-z\\u00a1-\\uffff]{2,})'
      : `(?:${tlds.sort((a, b) => b.length - a.length).join('|')})`
  })\\.?`
  const port = '(?::\\d{2,5})?'
  const path = '(?:[/?#][^\\s"]*)?'
  const regex = `(?:${protocol}|www\\.)${auth}(?:localhost|${host}${domain}${tld})${port}${path}`

  return options.exact
    ? new RegExp(`(?:^${regex}$)`, 'i')
    : new RegExp(regex, 'ig')
}

export const urlHasProtocol = (value: string): boolean => {
  const protocolRegex = /^(http|https):\/\//gi

  return protocolRegex.test(value)
}
